import { gql } from "@apollo/client"

export const CREATE_STUDENT = gql`
  mutation createStudent($data: CreateStudentRequest!) {
    student {
      create(data: $data) {
        id
        firstName
        lastName
        externalStudentId
        email
        username
        grade
        schoolId
        districtId
      }
    }
  }
`

export const UPDATE_STUDENT = gql`
  mutation updateStudent($data: UpdateStudentRequest!) {
    student {
      update(data: $data)
    }
  }
`

export const DELETE_STUDENTS = gql`
  mutation deleteStudents($data: StudentsIdsListRequest) {
    student {
      removeBatch(data: $data)
    }
  }
`
